import { IContentPackage } from '@imcc/transport';
import { Filter } from '@features/search/search-filters/filter/filter';
import { getInitialFilters } from './get-initial-filters';

export const FEATURE_KEY = 'contentPackages';

export class ContentPackagesState {
  nextOffset?: number;

  query: string;

  filters: Filter[];

  packages: {
    [slug: string]: IContentPackage;
  };
}

export const initialState: ContentPackagesState = {
  packages: {},
  query: '',
  filters: getInitialFilters(),
};
